import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { Product } from '../app/models/Product';
import { ConfigService } from '../providers/config/config.service';
import { GenericQueryParams } from '../utils/utils';
import { CommonService, GenericPaginatedDataType } from './common.service';

export type GetProductsType = GenericPaginatedDataType<Product>;

@Injectable()
export class ProductsService {
  constructor(private configService: ConfigService, private commonService: CommonService) {}

  addProduct(product: Product): Observable<Product> {
    let url = this.configService.getUrl() + 'products/';
    type typeToReturn = Product;
    let response = this.commonService.createData<typeToReturn>(url, product);
    return response;
  }

  saveOrUpdateProduct(product: Product): Observable<Product> {
    let edit = product.uuid != null;
    return edit ? this.editProduct(product) : this.addProduct(product);
  }

  editProduct(product: Product): Observable<Product> {
    let url = this.configService.getUrl() + 'products/' + product.uuid;
    type typeToReturn = Product;
    let response = this.commonService.editData<typeToReturn>(url, product);
    return response;
  }
  getPaginatedProducts(params: GenericQueryParams) {
    return this.commonService.getPaginatedQuery<GetProductsType>('products', params);
  }

  deleteProduct(product: Product) {
    let url = this.configService.getUrl() + 'products/' + product.uuid;
    type typeToReturn = Product;
    let response = this.commonService.deleteData<typeToReturn>(url);
    return response;
  }

  getProducts(): Observable<Product[]> {
    let url = this.configService.getUrl() + 'products/';
    type typeToReturn = Product[];
    let response = this.commonService.getData<typeToReturn>(url);
    return response;
  }
}



// WEBPACK FOOTER //
// ./src/services/products.service.ts